module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('img', {
    staticStyle: {
      "width": "80px"
    },
    attrs: {
      "src": _vm.testimonial.src,
      "alt": "Image"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "review_content"
  }, [_c('p', [_vm._v(_vm._s(_vm.description))]), _vm._v(" "), _c('div', {
    staticClass: "review_rating"
  }, _vm._l((new Array(5)), function(n, index) {
    return _c('i', {
      staticClass: "fa",
      class: {
        'fa-star': (index + 1) <= _vm.testimonial.rating, 'fa-star-o': (index + 1) > _vm.testimonial.rating
      },
      attrs: {
        "aria-hidden": "true"
      }
    })
  })), _vm._v(" "), _c('div', {
    staticClass: "review_author"
  }, [_vm._v(_vm._s(_vm.title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ba38972"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/testimonials/Testimonial.vue
// module id = 351
// module chunks = 0